import * as React from 'react'
import { FC, useCallback } from 'react'
import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import { SearchFilterType } from '@user/store/search/typings'
import Typography from '@mui/material/Typography'
import Switch from '@mui/material/Switch'
import {
  SearchFilterContainer,
  SearchFormControlLabel,
} from './SearchComponentStyles'
import { useTheme } from '@mui/material/styles'

export const defaultSearchFilter: SearchFilterType = {
  pendingLead: false,
  lead: false,
  opportunity: false,
  myRecords: false,
  closed: false,
}

interface Props {
  hideMyRecords?: boolean
  onChange: (f: SearchFilterType) => void
  filters: SearchFilterType
}

export const SearchFilters: FC<Props> = ({
  onChange,
  hideMyRecords,
  filters,
}: Props) => {
  const onCheckedUnChecked = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
      const filter = {
        ...filters,
        [e?.currentTarget.name]: checked,
      }
      onChange(filter)
    },
    [filters, onChange],
  )
  const theme = useTheme()
  return (
    <SearchFilterContainer>
      <Box pt={1} pb={0}>
        <SearchFormControlLabel
          label={<Typography variant="body2">Pending Lead</Typography>}
          control={
            <Checkbox
              color="primary"
              name="pendingLead"
              onChange={onCheckedUnChecked}
              checked={filters?.pendingLead}
              data-test-id="pendingLeadFilterCheckbox"
            />
          }
        />

        <SearchFormControlLabel
          label={<Typography variant="body2">Lead</Typography>}
          control={
            <Checkbox
              color="primary"
              name="lead"
              onChange={onCheckedUnChecked}
              checked={filters?.lead}
              data-test-id="leadFilterCheckbox"
            />
          }
        />

        <SearchFormControlLabel
          label={<Typography variant="body2">Opportunity</Typography>}
          control={
            <Checkbox
              color="primary"
              name="opportunity"
              onChange={onCheckedUnChecked}
              checked={filters?.opportunity}
              data-test-id="opportunityFilterCheckbox"
            />
          }
        />
      </Box>
      <Box
        display="flex"
        flexDirection="row"
        mr={1}
        ml={1}
        pt={2}
        sx={{
          [theme.breakpoints.down('md')]: {
            paddingTop: theme.spacing(0),
          },
        }}
      >
        {!hideMyRecords && (
          <SearchFormControlLabel
            sx={{ marginRight: theme.spacing(0) }}
            labelPlacement="end"
            label={<Typography variant="body2">My Records </Typography>}
            control={
              <Switch
                size="small"
                name="myRecords"
                checked={filters?.myRecords}
                onChange={onCheckedUnChecked}
                data-test-id="myRecordsFilterSwitch"
              />
            }
          />
        )}

        <SearchFormControlLabel
          sx={{ marginLeft: theme.spacing(1), marginRight: 'auto' }}
          labelPlacement="end"
          label={<Typography variant="body2">Closed Records </Typography>}
          control={
            <Switch
              size="small"
              name="closed"
              checked={filters?.closed}
              onChange={onCheckedUnChecked}
              data-test-id="closedRecordsFilterSwitch"
            />
          }
        />
      </Box>
    </SearchFilterContainer>
  )
}
